import React from 'react';
import { useSelector } from 'react-redux';
import { search3, FILTER_ICON, RED_FILTER_ICON } from '../../paths/defaultImage';
import LazyImage from '../common/lazyLoad';

const Filter = ({ menu, setVegCheck, vegCheck, setFilterPopup, setOpenSeachPopUp }) => {
  const isFilterSelected = useSelector((store) => store.menuFilterReducer).some(
    (filter) => filter.selected === true
  );
  const handleChange = (checked) => {
    setVegCheck(checked);
  };

  return (
    <>
      <div className='pointer'>
        <LazyImage
          src={search3}
          alt='search'
          onClick={() => {
            setOpenSeachPopUp(true);
          }}
          height={18}
          width={18}
        />
      </div>
      <div className='pointer'>
        <LazyImage
          src={isFilterSelected ? RED_FILTER_ICON : FILTER_ICON}
          alt='filter'
          onClick={() => {
            setFilterPopup(true);
          }}
          height={18}
          width={19}
        />
      </div>
    </>
  );
};

export default Filter;
